import clsx from 'clsx';
import styles from './icon.module.css';

type EmojiSizes = 'small' | 'normal' | 'large';

interface MBEmojiIconProps {
  emoji: string;
  size?: EmojiSizes;
}

export function MBEmojiIcon({ emoji, size = 'normal' }: MBEmojiIconProps) {
  const sizeClassName = getEmojiSizeClassName(size);
  return <span className={clsx(styles.emoji, sizeClassName)}>{emoji}</span>;
}

function getEmojiSizeClassName(size: EmojiSizes) {
  if (size === 'small') {
    return styles.small;
  }
  if (size === 'large') {
    return styles.large;
  }
}
